import React from 'react';
import styled from '@mui/system/styled';
import { Paper, TextField, Typography } from '@mui/material';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { DateString } from 'routes/HumanResourcesModule/business/types';
import {
    getHrPreviousSimulationApiInfo,
    getHrSimulationHistoricApiInfo,
} from './helpers/apiHelpers';
import HistoricDataGrid from '../components/ValueByDate/HistoricDataGrid';
import PreviousSimulationDataGrid from '../components/ValueByDate/PreviousSimulationDataGrid';
import { EnvelopeField, EnvelopeHypothesis } from './helpers/types';

const StyModalSection = styled(Paper, { name: 'StyModalSection' })({
    padding: '1rem',
    '& + &': {
        marginTop: '1.5rem',
    },
});

type Props = {
    hrSimulation: HrSimulation;
    orgChartHrSoftwareId: string;
    envelopeFieldValue: string;
    envelopeField: EnvelopeField;
    onValuesByDatesChange: (
        newValuesByDates: Record<DateString, number>,
    ) => void;
    setHasChanges: React.Dispatch<React.SetStateAction<boolean>>;
    comment: string;
    isNonRecurrentEnvelope?: boolean;
    setComment: React.Dispatch<React.SetStateAction<string>>;
    commentFieldLabel: string;
    translationKey: string;
    hypothesis?: EnvelopeHypothesis | null;
    isUpdateEnabled: boolean;
};

const EnvelopeHypothesisModalContent = ({
    hrSimulation,
    orgChartHrSoftwareId,
    envelopeFieldValue,
    envelopeField,
    isNonRecurrentEnvelope = false,
    onValuesByDatesChange,
    setHasChanges,
    comment,
    setComment,
    commentFieldLabel,
    translationKey,
    hypothesis = null,
    isUpdateEnabled,
}: Props) => {
    const { apiCacheKey: historicApiKey, endpoint: historicEndpoint } =
        getHrSimulationHistoricApiInfo(hrSimulation.id, envelopeField);

    const {
        apiCacheKey: previousSimulationApiKey,
        endpoint: previousSimulationEndpoint,
    } = getHrPreviousSimulationApiInfo(hrSimulation.id, envelopeField);

    const filters = {
        [envelopeField]: envelopeFieldValue,
        orgChartHrSoftwareId,
    };
    return (
        <>
            <StyModalSection elevation={0}>
                <HistoricDataGrid
                    hrSimulation={hrSimulation}
                    filters={filters}
                    isNonRecurrentEnvelope={isNonRecurrentEnvelope}
                    apiCacheKey={historicApiKey}
                    endpoint={historicEndpoint}
                    translationKey={translationKey}
                />
            </StyModalSection>
            <StyModalSection elevation={0}>
                <PreviousSimulationDataGrid
                    hrSimulation={hrSimulation}
                    filters={filters}
                    hypothesis={hypothesis}
                    isNonRecurrentEnvelope={isNonRecurrentEnvelope}
                    onValuesByDatesChange={onValuesByDatesChange}
                    setHasChanges={setHasChanges}
                    isUpdateEnabled={isUpdateEnabled}
                    apiCacheKey={previousSimulationApiKey}
                    endpoint={previousSimulationEndpoint}
                    translationKey={translationKey}
                />
            </StyModalSection>
            <StyModalSection elevation={0}>
                <Typography variant="h4">{commentFieldLabel}</Typography>
                <TextField
                    fullWidth
                    multiline
                    disabled={!isUpdateEnabled}
                    value={comment}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setComment(e.target.value);
                    }}
                />
            </StyModalSection>
        </>
    );
};

export default EnvelopeHypothesisModalContent;
